import Layout from "./Container/Layout";
import 'bootstrap/dist/css/bootstrap.min.css';
import {connect} from "react-redux";
import * as Action from "./Store/Action";
import React from "react"
import {Redirect} from "react-router-dom";

class App  extends React.Component{
 componentDidMount = ()=>{
   this.props.fetch_from_local()
   this.props.fetch_task_from_local()
 } 
 render(){
  return (
    <React.Fragment>
       <Redirect to="/tasks"></Redirect>
       <Layout></Layout>
    </React.Fragment>
    
   );
 }
}
const mapStateToProps = state =>{
  return {
    cropsland:state.croplands
  }
}
const mapDispatchToProps = dispatch =>{
  return {
    fetch_from_local:()=>dispatch({type:Action.FETCH_FROM_LOCAL_STORAGE}),
    fetch_task_from_local:()=>dispatch({type:Action.FETCH_TASK_FROM_LOCAL_STORAGE})
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(App);